import axios from '@/plugins/axios';

export async function me(conf = {}){
    return await axios.post('auth/me', {}, conf);
}

export async function register(creds){
    return await axios.post('auth/register', creds);
}

export async function refresh(){
    return await axios.post('auth/refresh');
}

export async function subscription(){
    return await axios.get('auth/subscription');
}

export async function logout(){
    return await axios.post('auth/logout');
}

export async function profile(userId){
    return await axios.get(`user/${userId}/profile`);
}

export async function profileUpdate(userId, data, options = {}){
    return await axios.post(`user/${userId}/profile`, data, options);
}

export async function contactRemove(contactId){
    return await axios.delete(`user/user-contacts/${contactId}`);
}

export async function contactAdd(type, contact){
    return await axios.post(`user/user-contacts`, {type, contact});
}

export async function changePassword(userId, data){
    return await axios.post(`user/${userId}/reset-password`, data);
}

export async function changeEmailSend(userId, data){
    return await axios.post(`user/${userId}/change-email/send`, data);
}

export async function changeEmailConfirm(userId, data){
    return await axios.post(`user/${userId}/change-email/confirm`, data);
}

export async function generateApiToken(userId){
    return await axios.post(`user/${userId}/api-token/generate`);
}

export async function getApiToken(userId){
    return await axios.get(`user/${userId}/api-token`);
}